import { render, staticRenderFns } from "./TailwindBreakpoints.vue?vue&type=template&id=f25e2de6"
import script from "./TailwindBreakpoints.vue?vue&type=script&lang=js"
export * from "./TailwindBreakpoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports